<template>
  <el-dialog
    :title="getTitle()"
    :visible="isDiaShow"
    width="40%"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <el-form
      ref="entityData"
      :model="entityData"
      :rules="rules"
      label-width="110px"
      class="demo-ruleForm"
      label-position="right"
    >
      <el-form-item label="标题" prop="Title">
        <el-input v-model="entityData.Title" maxlength="50" />
      </el-form-item>

      <el-form-item label="内容" prop="Content">
        <el-input v-model="entityData.Content" type="textarea" :rows="5" maxlength="100" />
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSend()">发  送</el-button>
    </div>

  </el-dialog>
</template>
<script>
import pathReq from '@/api/pathlist'
export default {
  data() {
    return {
      isDiaShow: false,
      entityData: {},
      toUserId: null,
      toUserName: '',
      rules: {
        Title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        Content: [{ required: true, message: '请输入内容', trigger: 'blur' }]
      }
    }
  },
  methods: {
    getTitle() {
      return this.toUserName + '--发送私信'
    },
    showDialog(toUserId, toUserName) {
      this.toUserId = toUserId
      this.toUserName = toUserName
      this.isDiaShow = true
    },
    handleClose() {
      this.$refs.entityData.resetFields()
      this.isDiaShow = false
    },
    /** 发送 */
    handleSend() {
      const that = this
      this.$refs['entityData'].validate(valid => {
        if (valid) {
          var data = {
            toUserId: this.toUserId,
            title: this.entityData.Title,
            content: this.entityData.Content
          }
          var path = '/api/services/app/WorkNotification/AddNotify04'
          pathReq.dataUpdate(path, data).then((r) => {
            that.$message.success('发送成功')
            that.$refs.entityData.resetFields()
            that.isDiaShow = false
          })
        }
      })
    }
  }
}
</script>
<style scoped>
.el-dialog__body {
  padding-top: 10px !important;
}

.dialog-footer {
  margin-top: 10px;
  text-align: right;
}

.el-select {
  margin-right: 8px;
  width: 100% !important;
}
</style>
